<template>
  <div class="slide">
    <Header>
      {{ answers.text }}
      <template v-slot:subtext>
        {{ answers.subtext }}
      </template>
    </Header>

    <div class="grid-container grid-container--small">
      <div class="grid-x">
        <div class="small-12 colums text-left">
          <div
            class="answers"
            v-for="(option, i) in answers.responses"
            :key="i"
          >
            <input
              v-model="answer"
              class="answer"
              :id="`answer-${i}`"
              name="answer"
              type="radio"
              :value="option.value"
              @click="
                allowNext();
                clicked = true;
              "
            /><label class=" text-center" :for="`answer-${i}`"
              ><span>{{ option.text }}</span></label
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import quiz from "../../appdata/quiz.js";
import Header from "../common/Header";
export default {
  components: {
    Header: Header,
  },
  mounted() {
    this.clicked = false;
    var answerIndex = this.storeAnswer
      .map((item) => item.id)
      .indexOf(this.index);
    if (answerIndex > -1) {
      this.answer = this.storeAnswer[answerIndex].value;
      this.$eventBus.$emit("allowNext", true);
    } else {
      this.$eventBus.$emit("allowNext", false);
    }
  },
  data() {
    return {
      quiz: quiz,
      answer: null,
      clicked: false,
    };
  },
  methods: {
    allowNext() {
      this.$eventBus.$emit("allowNext", true);
    },
    next() {
      this.$eventBus.$emit("nav", "next");
    },
  },
  watch: {
    // whenever question changes, this function will run
    answer: function(newAnswer, oldAnswer) {
      let answers = this.storeAnswer;
      const answer = {
        id: this.index,
        value: newAnswer,
      };
      var removeIndex = answers.map((item) => item.id).indexOf(this.index);
      ~removeIndex && answers.splice(removeIndex, 1);
      answers.push(answer);
      this.storeAnswer = answers;
      if (this.clicked) {
        this.next();
      }
    },
  },
  computed: {
    id: {
      get() {
        return parseInt(this.$route.path.substring(1));
      },
    },
    answers: {
      get() {
        return this.quiz.questions[this.index];
      },
    },
    index: {
      get() {
        let splitName = this.$route.name.split("-");
        return parseInt(splitName[1]) - 1;
      },
    },
    storeAnswer: {
      get() {
        return this.$store.state.answers;
      },
      set(value) {
        this.$store.commit("setAnswers", { answers: value });
      },
    },
  },
};
</script>

<style lang="scss">
.answers {
  label {
    text-align: left;
  }
}

.answers {
  label {
    @media (min-width: 768px) {
      font-size: 25px;
    }
    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
}

input.answer {
  display: none;
  + label {
    padding-left: 50px;
    position: relative;
    &:before {
      border: 2px solid #083650;
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -13px;
      width: 26px;
      height: 26px;
      content: "";
      border-radius: 50%;
    }
    &:hover,
    &:focus,
    &:active {
      color: inherit !important;
      opacity: 1 !important;
    }
  }
  &:checked + label {
    &:after {
      position: absolute;
      left: 5px;
      top: 50%;
      margin-top: -8px;
      width: 16px;
      height: 16px;
      content: "";
      border-radius: 50%;
      background: #083650;
    }
  }
}
</style>
